import React from "react";
import { Navigate, Outlet, useLocation  } from "react-router-dom";

const ProtectedRoute = () => {
    const token = localStorage.getItem("accessToken");
    const locationUid = localStorage.getItem("locationUid");
    const currentPath = useLocation().pathname;

    if (!token) return <Navigate to="/login" replace />; 
    if (!locationUid && currentPath !== "/choose-location") return <Navigate to="/choose-location" replace />; 

    return <Outlet />;
};

export default ProtectedRoute;
